import { Button, Flex, Layout, Menu, Typography } from "antd";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { executeLogoutHandler } from "@/utils/logoutHandler";

const { Header } = Layout;

const Topbar = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      // Execute page-specific logout handler
      const shouldLogout = await executeLogoutHandler(location.pathname);

      if (shouldLogout) {
        logout();
      }
    } catch (error) {
      // Fallback: proceed with logout if handler fails
      logout();
    }
  };

  const getMenuItems = () => {
    return [
      {
        key: "/expenses/record",
        label: "Expenses",
      },
    ];
  };

  return (
    <Header
      className="topbar"
      style={{
        height: 64,
        width: "100%",
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        padding: "0 32px",
      }}
    >
      <Flex vertical={false} align="center" gap={8} justify="center">
        <Typography.Text style={{ fontSize: 16 }} strong>
          Kraken
        </Typography.Text>
      </Flex>
      <Menu
        theme="light"
        mode="horizontal"
        defaultSelectedKeys={[location.pathname]}
        items={getMenuItems()}
        style={{
          flex: 1,
          width: "100%",
          border: "none",
          justifyContent: "flex-end",
        }}
      />
      <Flex
        vertical={false}
        align="center"
        gap={8}
        justify="center"
        style={{
          height: "min-content",
          overflow: "hidden",
        }}
      >
        <Button
          type="text"
          className="logout-button"
          onClick={handleLogout}
          style={{
            color: "grey",
            backgroundColor: "transparent",
            paddingRight: 0,
            marginRight: 0,
          }}
          size="small"
        >
          Logout
        </Button>
      </Flex>
    </Header>
  );
};

export default Topbar;
